import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { userReceivedAction } from '@root/entities/auth'
import { fetchMeRequestAction } from '@root/features/auth/authenticate/atoms/auth-requests'
import { putUserToWorkerAction } from '@root/features/shared-worker/atoms'
import { ApiError } from '@root/shared/api'
import { reatomResource } from '@root/shared/lib'

export const meStateAtom = reatomResource(
  async (ctx) => {
    const result = await ctx.schedule(() => fetchMeRequestAction(ctx))
    if (Result.isSuccess(result)) {
      userReceivedAction(ctx, result.success)
      putUserToWorkerAction(ctx, result.success)
    }
    return result
  },
  // eslint-disable-next-line @reatom/unit-naming-rule
  {
    name: 'meStateAtom',
    loadOnConnect: false,
    retry: {
      enabled: true,
      retryOn: (error) => !ApiError.isUnauthorizedOrExpired(error),
    },
  },
)

export const initializeUserAction = action(async (ctx) => {
  meStateAtom.run(ctx)
}, 'initializeUserAction')

export const refreshUserAction = action(async (ctx) => {
  meStateAtom.refresh(ctx)
}, 'refreshUserAction')

const _listenWindowEventAction = action(async (ctx) => {
  const handleVisibility = async () => {
    if (document.visibilityState === 'visible') {
      const me = await ctx.schedule(() => fetchMeRequestAction(ctx))

      if (Result.isFailure(me)) {
        return
      }

      userReceivedAction(ctx, me.success)
    }
  }

  document.addEventListener('visibilitychange', handleVisibility, {
    passive: true,
  })
}, '__listenWindowEventAction')
